import { connect } from 'react-redux';
import BgSlider from '../components/BgSlider';
import { findPrevNextFromUri, trUri } from '../utils';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions/bgslider';
import { GOTO_SECTION } from '../actions/navigation';

function mapStateToProps(state, ownProps) {
  // do not iterate on subsections
  // const uri = `/${state.routing.locationBeforeTransitions.pathname.split('/')[2]}`;
  const items = state.luraschi.getIn(['data', 'data']).map(i => i.get('meta'));

  // const current = items.findKey(item => item.get('uri') === uri);
  // const nextUri = items.skip(current).rest().first().get('uri');
  const uri = ownProps.location.pathname;
  const universalUri = `/${uri.split('/')[2]}`;
  const sections = state.luraschi.getIn(['data', 'data']).map(i => i.get('meta'));
  const lang = state.luraschi.get('lang', 'fr');
  const currentIndex = sections.findKey(item => trUri(item, lang) === universalUri) || 0;
  const prevnext = findPrevNextFromUri(items, universalUri, lang);
  return {
    items,
    nextUri: (typeof prevnext[1] !== 'undefined') ? `/${lang}${trUri(prevnext[1], lang)}` : uri,
    lang,
    ponies: state.luraschi.get('ponies', false),
    locked: state.luraschi.getIn(['slider', 'locked'], false),
    currentIndex,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
    sliderBtn: (uri) => browserHistory.push(uri),
    showSection: () => dispatch({ type: GOTO_SECTION }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BgSlider);



// WEBPACK FOOTER //
// ./common/containers/BgSlider.js